import { render, staticRenderFns } from "./DisagreeExistingChildSupport.vue?vue&type=template&id=68cce58f"
import script from "./DisagreeExistingChildSupport.vue?vue&type=script&lang=ts"
export * from "./DisagreeExistingChildSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports